import { Routes, Route, Navigate } from "react-router-dom";

import { useAuth } from "context/providers/auth";
import NotificationProvider from "context/providers/notifications";
import WorkersProvider from "context/providers/workers";
import CustomCommentsProvider from "context/providers/custom_comments";
import IssueKindsProvider from "context/providers/issue_kinds";

import SignIn from "views/auth/SignIn";
import UserInvitation from "views/auth/UserInvitation";
import SignUp from "views/auth/SignUp";
import ConfirmEmail from "views/auth/ConfirmEmail";
import ResetPassword from "views/auth/ResetPassword";
import ChangePassword from "views/auth/ChangePassword";

import OtpAuthPanel from "components/OtpAuthPanel";
import ActivityProtect from "components/ActivityProtect";
import Loader from "components/Loader";
import Main from "components/Main";

const AppRouter = () => {
  const {
    state: { is_loading, otp_auth_needed, is_logged },
  } = useAuth();

  if (is_loading) {
    return <Loader />;
  }

  if (otp_auth_needed) {
    return (
      <Routes>
        <Route path="*" element={<OtpAuthPanel />} />
      </Routes>
    );
  }

  if (!is_logged) {
    return (
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/confirm-email" element={<ConfirmEmail />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/invitations/:id" element={<UserInvitation />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    );
  }

  return (
    <ActivityProtect>
      <WorkersProvider>
        <IssueKindsProvider>
          <CustomCommentsProvider>
            <NotificationProvider>
              <Main />
            </NotificationProvider>
          </CustomCommentsProvider>
        </IssueKindsProvider>
      </WorkersProvider>
    </ActivityProtect>
  );
};

export default AppRouter;
